/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */
/* eslint-disable prefer-promise-reject-errors */

'use es6';

import quickFetch from 'quick-fetch';
import { fromJS, Map as ImmutableMap } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { fetchDashboardSingle } from 'dashboard-lib/public/dashboard/dashboard-dao';
const DASHBOARD_URL = 'dashboard/v2/dashboard';
const CACHE_TIMEOUT = 60 * 1000;
let cache = ImmutableMap();
let timers = ImmutableMap();
export const clearDashboardCache = id => {
  const key = ['dashboard', id];
  clearTimeout(timers.getIn(key));
  cache = cache.deleteIn(key);
};
export const clearDashboardsCache = () => {
  const key = 'dashboards';
  clearTimeout(timers.get(key));
  cache = cache.delete(key);
};
export const getDashboard = id => {
  const key = ['dashboard', id];
  if (!cache.hasIn(key)) {
    cache = cache.setIn(key, fetchDashboardSingle({
      id
    }).then(dashboards => {
      timers = timers.set(key, setTimeout(clearDashboardCache(id), CACHE_TIMEOUT));
      return dashboards;
    }));
  }
  return cache.getIn(key);
};
export const getAllDashboards = (options = {}) => {
  const get = () => http.get(DASHBOARD_URL, {
    query: Object.assign({}, options)
  }).then(fromJS);
  const earlyRequest = quickFetch.getRequestStateByName('dashboards');
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(request => {
        resolve(fromJS(request));
        quickFetch.removeEarlyRequest('dashboards');
      });
      earlyRequest.onError(xhr => {
        if (xhr.status !== 401) {
          get().then(resolve, reject);
        } else {
          reject();
        }
        quickFetch.removeEarlyRequest('dashboards');
      });
    });
  } else {
    return get();
  }
};
export const getDashboards = () => {
  const key = 'dashboards';
  if (!cache.has(key)) {
    cache = cache.set(key, http.get(DASHBOARD_URL, {
      query: {
        hydrate: 'USER_PERMISSION_LEVEL'
      }
    }).then(fromJS).then(dashboards => {
      timers = timers.set(key, setTimeout(clearDashboardsCache, CACHE_TIMEOUT));
      return dashboards;
    }));
  }
  return cache.get(key);
};
export const addExistingReportToDashboard = (reportId, dashboardId) => {
  return http.post(`${DASHBOARD_URL}/add-existing-report-to-dashboard/${dashboardId}`, {
    data: {
      layout: {
        height: 1,
        width: 1,
        x: null,
        y: 100
      },
      reportId
    }
  }).then(fromJS);
};
export const addReportsToDashboard = (reportIds, dashboardId) => {
  return http.post(`${DASHBOARD_URL}/${dashboardId}/widget/from-reports`, {
    data: reportIds
  }).then(fromJS);
};